const axios = require('axios');

const url = process.env.BASE_URL || "https://gratitudemap-back.herokuapp.com/message/";
const api = axios.create({
    baseURL: url
});


export default api;

